/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcBillingV1ChargeState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_BILLING_V1_CHARGE_STATE_ENTITY_NAME = 'ixc.billing.v1.Charge';
export const ixcBillingV1ChargeStateEntity = new schema.Entity<IxcBillingV1ChargeState>(IXC_BILLING_V1_CHARGE_STATE_ENTITY_NAME, {}, { idAttribute: 'chargeId' });

